/* eslint-disable*/
import { Box, Typography } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { currentchannel } from 'feactures/channel/channelSlice';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const AMAZON_MARKET_PATHS = [
  '/app/newcategoryboard',
  '/app/brandanalysis',
  '/app/brandcomparison',
  '/app/otherproductboard'
];

const AMAZON_SEP2026_NOTICE_START = '2026-10-01';
const AMAZON_SEP2026_NOTICE_END = '2026-10-04';
const AMAZON_SEP2026_NOTICE =
  'Amazonマーケット9月分は、データ取得遅延のため準備中です。10月4日頃に反映予定です。';

const RAKUTEN_ONAMAE_PATHS = [
  '/app/measureanalysis',
  '/app/performancereview'
];
const ONAMAE_MAINT_NOTICE_START = '2026-10-21';
const ONAMAE_MAINT_NOTICE_END = '2026-10-31';
const ONAMAE_MAINT_NOTICE =
  'サーバーのメンテナンス実施により、10月20日以降のデータが現在表示されません。※復旧まで期間が延びる可能性があります';

const toLocalYmd = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const StickyAnnotation = () => {
  const location = useLocation();
  const [content, setContent] = useState('');
  const [isOpen, setIsOpen] = useState(true);
  const channel = useSelector(currentchannel);

  useEffect(() => {
    // Amazon マーケットビュー: 9月分反映遅延の一時警告（10/1〜10/4）
    if (AMAZON_MARKET_PATHS.includes(location.pathname) && channel === 1) {
      const today = toLocalYmd(new Date());
      if (
        today >= AMAZON_SEP2026_NOTICE_START
          && today <= AMAZON_SEP2026_NOTICE_END
      ) {
        setContent(AMAZON_SEP2026_NOTICE);
        return;
      }
    }

    // 楽天 競合施策分析・商品販売力診断: お名前.com停止による欠測の一時警告
    if (RAKUTEN_ONAMAE_PATHS.includes(location.pathname) && channel === 2) {
      const today = toLocalYmd(new Date());
      if (
        today >= ONAMAE_MAINT_NOTICE_START
          && today <= ONAMAE_MAINT_NOTICE_END
      ) {
        setContent(ONAMAE_MAINT_NOTICE);
        return;
      }
    }

    switch (location.pathname) {
      // /app/monitoring 以下すべてにマッチ
      // case location.pathname.startsWith('/app/monitoring'):
      // case location.pathname.startsWith('/app/overview'):
      //   if (channel === 1) {
      //     setContent(
      //       'ベンダーセントラルをご利用の場合に、レポートで取得の遅延が発生しております。※セラーセントラルは影響ありません。'
      //     );
      //   }
      //   break;

      case '/app/monitoring/asin':
        setContent(
          '楽天 > KPIビュー > 商品別データが表示されていません。 (解消時期未定) '
        );
        break;
      case '/app/numberviews':
        if (channel == 1) {
          setContent(
            '・掲載順位（自然検索）、掲載順位（スポンサー）は現在レポートが正常に取得出来ない問題が発生しております。それに伴い、新規のキーワード登録を一時的に停止をさせて頂いております。\n※解消に向けて動いておりますが、現時点で目途は未定となります。'
          );
        } else {
          setContent('');
        }
        break;
      case '/app/keywords/detail':
        if (channel == 1) {
          setContent(
            '指名検索数の登録時に、2回連続で登録ができない事象が発生しています。一度リロードすると、登録が可能です。（解消時期未定）'
          );
        } else {
          setContent('');
        }
        break;
      case '/app/asin':
        setContent(
          '表示速度が遅い場合がありますがご了承ください。(4月中旬解消予定)'
        );
        break;
      case '/app/measureanalysis':
        setContent('');
        break;
      // case '/app/performancereview':
      //   if (channel == 2) {
      //     setContent(
      //       <>
      //         データの取得ができない事象が発生しています。
      //         <br />
      //         対象：2月　2/7ごろ復旧次第、データの反映を予定しています
      //       </>
      //     );
      //   }
      //   break;
      default:
        setContent('');
        break;
    }
  }, [location.pathname, channel]);

  const handleClick = () => {
    setIsOpen(false);
  };

  return (
    <Box sx={{ pt: 1 }}>
      {isOpen && content && (
        <Box
          py={1}
          px={2}
          mb={1}
          // border={3}
          // borderColor="#ED7D31"
          borderRadius={2}
          bgcolor="rgba(244,204,204,1)"
          display="flex"
          justifyContent="space-between"
        >
          <Typography variant="caption" whiteSpace="pre-wrap" color="#990000">
            {content}
          </Typography>
          <CloseIcon
            onClick={handleClick}
            sx={{
              alignSelf: 'flex-start',
              cursor: 'pointer',
              color: '#990000'
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default StickyAnnotation;
